import React from "react";

export const UserIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20"
    viewBox="0 0 13 14"
    fill="none"
    {...props}
  >
    <path
      d="M11.839 13.1503L11.839 11.8018C11.839 11.0865 11.5548 10.4005 11.049 9.89468C10.5432 9.38889 9.85723 9.10474 9.14193 9.10474L3.74783 9.10474C3.03253 9.10474 2.34652 9.38889 1.84073 9.89468C1.33493 10.4005 1.05078 11.0865 1.05078 11.8018L1.05078 13.1503"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.44314 6.40899C7.93268 6.40899 9.14019 5.20148 9.14019 3.71194C9.14019 2.2224 7.93268 1.01489 6.44314 1.01489C4.9536 1.01489 3.74609 2.2224 3.74609 3.71194C3.74609 5.20148 4.9536 6.40899 6.44314 6.40899Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
